"use client";

import { useEffect } from "react";

type NeoScriptsProps = {
	scripts: string;
	slug: string;
};

const NeoScripts = ({ scripts, slug }: NeoScriptsProps) => {
	useEffect(() => {
		const script = document.createElement("script");
		script.textContent = scripts;
		document.body.appendChild(script);

		return () => {
			script.remove();
		};
	}, [scripts, slug]);

	return null;
};

export default NeoScripts;
